<template>
  <div class="profile">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">Casual Worker Profile</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Profile</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="card mb-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="profile-view">
                    <div class="profile-img-wrap">
                      <div class="profile-img">
                        <a @click="openChangePhoto"
                          ><img
                            alt=""
                            :src="media + employee.passportPhoto"
                            v-if="employee.passportPhoto"/>
                          <img
                            alt=""
                            src="~@/assets/profiles/avatar-02.jpg"
                            v-if="!employee.passportPhoto"
                        /></a>
                      </div>
                    </div>
                    <div class="profile-basic">
                      <div class="row">
                        <div class="col-md-5">
                          <div class="profile-info-left">
                            <h3 class="user-name m-t-0 mb-0">
                              {{ employee.firstName + " " + employee.lastName }}
                            </h3>
                            <h6 class="text-muted">
                              {{ employee.designation.name }}
                            </h6>
                            <small class="text-muted">{{
                              employee.designation.department.name
                            }}</small>
                            <div class="staff-id">
                              Employee ID : {{ employee.casualWorkerCode }}
                            </div>
                            <div class="small doj text-muted">
                              Date of Join :
                              {{
                                new Date(
                                  employee.createdAt
                                ).toLocaleDateString()
                              }}
                            </div>
                            <!-- <div class="staff-msg">
                              <router-link to="/chat" class="btn btn-custom"
                                >Send Message
                              </router-link>
                            </div> -->
                          </div>
                        </div>
                        <div class="col-md-7">
                          <ul class="personal-info">
                            <li>
                              <div class="title">Phone:</div>
                              <div class="text">
                                {{ employee.phone }}
                              </div>
                            </li>
                            <li>
                              <div class="title">Birthday:</div>
                              <div class="text">
                                {{
                                  new Date(
                                    employee.birthday
                                  ).toLocaleDateString()
                                }}
                              </div>
                            </li>
                            <li>
                              <div class="title">Address:</div>
                              <div class="text">{{ employee.address }}</div>
                            </li>
                            <li>
                              <div class="title">Gender:</div>
                              <div class="text">{{ employee.gender }}</div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="pro-edit">
                      <a @click="openProfile" class="edit-icon" href="#"
                        ><i class="fa fa-pencil"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card tab-box">
            <div class="row user-tabs">
              <div class="col-lg-12 col-md-12 col-sm-12 line-tabs">
                <ul class="nav nav-tabs nav-tabs-bottom">
                  <li class="nav-item">
                    <a
                      href="#emp_profile"
                      data-toggle="tab"
                      class="nav-link active"
                      >Profile</a
                    >
                  </li>

                  <li class="nav-item">
                    <a href="#bank_statutory" data-toggle="tab" class="nav-link"
                      >Bank & Statutory</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="tab-content">
            <!-- Profile Info Tab -->
            <div
              id="emp_profile"
              class="pro-overview tab-pane fade show active"
            >
              <div class="row">
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Personal Informations
                        <a href="#" class="edit-icon" @click="openPersonalInfo"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <ul class="personal-info">
                        <li>
                          <div class="title">Passport No.</div>
                          <div class="text">
                            {{ employee.passportIdentificationNumber }}
                          </div>
                        </li>
                        <li>
                          <div class="title">Passport Exp Date.</div>
                          <div class="text">
                            {{
                              new Date(
                                employee.passportExpiryDate
                              ).toLocaleDateString()
                            }}
                          </div>
                        </li>
                        <li>
                          <div class="title">NIN</div>
                          <div class="text">
                            {{ employee.nationalIdentityNumber }}
                          </div>
                        </li>
                        <li>
                          <div class="title">Tel</div>
                          <div class="text">
                            {{ employee.phone }}
                          </div>
                        </li>
                        <li>
                          <div class="title">Nationality</div>
                          <div class="text">{{ employee.nationality }}</div>
                        </li>
                        <li>
                          <div class="title">Religion</div>
                          <div class="text">{{ employee.religion }}</div>
                        </li>
                        <li>
                          <div class="title">Marital status</div>
                          <div class="text">{{ employee.maritalStatus }}</div>
                        </li>
                        <li>
                          <div class="title">Employment of spouse</div>
                          <div class="text">
                            {{ employee.employmentOfSpouse }}
                          </div>
                        </li>
                        <li>
                          <div class="title">No. of children</div>
                          <div class="text">{{ employee.noOfChildren }}</div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Bank information
                        <a href="#" class="edit-icon" @click="openBankInfo"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <ul
                        class="personal-info"
                        v-if="employee.casualWorkerBank"
                      >
                        <li>
                          <div class="title-label">Bank name</div>
                          <div class="text">
                            {{ employee.casualWorkerBank.bankName }}
                          </div>
                        </li>
                        <li>
                          <div class="title-label">Bank account No.</div>
                          <div class="text">
                            {{ employee.casualWorkerBank.bankAccountNumber }}
                          </div>
                        </li>
                        <li>
                          <div class="title-label">Bank Verification No.</div>
                          <div class="text">
                            {{ employee.casualWorkerBank.bvnNumber }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Profile Info Tab -->
            <!-- Bank Statutory Tab -->
            <div class="tab-pane fade" id="bank_statutory">
              <div class="card">
                <div class="card-body">
                  <h3 class="card-title">Tax Information</h3>
                  <form @submit.prevent="onPostStatutory">
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Tax Identification No.
                            <span class="text-danger">*</span></label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-model="employee.casualWorkerTax.tin"
                            placeholder="Type your tax identification number"
                          />
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Tax State <span class="text-danger">*</span></label
                          >
                          <select
                            class="form-control"
                            v-model="employee.casualWorkerTax.taxCode"
                            @change="changeTax($event)"
                          >
                            <option>Select Tax State</option>
                            <option
                              v-for="item in taxOffices"
                              :key="item.taxOffice"
                              :value="item.taxOffice"
                              >{{ item.description }}</option
                            >
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="submit-section">
                      <button class="btn btn-primary submit-btn" type="submit">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /Bank Statutory Tab -->
          </div>
        </div>
        <!-- /Page Content -->
        <personal-info-modal
          :model="employee"
          :dialog="personalInfoDialog"
          v-if="personalInfoDialog"
          :method="closePersonalInfo"
        ></personal-info-modal>
        <profile-modal
          :model="employee"
          :dialog="profileDialog"
          v-if="profileDialog"
          :method="closeProfile"
        ></profile-modal>
        <bank-info-modal
          :model="employee.casualWorkerBank"
          :id="this.$route.params.id"
          :dialog="bankInfoDialog"
          v-if="bankInfoDialog"
          :method="closeBankInfo"
        ></bank-info-modal>
        <v-dialog v-model="changePhotodialog" max-width="230px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Change Photo</h5>
              <button type="button" class="close" @click="closeChangePhoto">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-md-12">
                <img alt="" :src="file" width="200" />
              </div>
              <div class="col-md-12">
                <button class="btn btn-info" @click="handleFileUpload">
                  Change Photo
                </button>
                <input
                  type="file"
                  style="display: none"
                  ref="file"
                  accept="image/*"
                  @change="onFilePicked"
                />
              </div>
            </div>
          </div>
        </v-dialog>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import PersonalInfoModal from "@/components/casualworker/CPersonalInfoModal.vue";
import ProfileModal from "@/components/casualworker/CProfileModal.vue";
import BankInfoModal from "@/components/casualworker/CBankInfoModal.vue";
import Datepicker from "vuejs-datepicker";
import { required, sameAs } from "vuelidate/lib/validators";
import { workerService } from "@/services/workerService.js";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
import { paymentService } from "@/services/paymentService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    PersonalInfoModal,
    ProfileModal,
    BankInfoModal
  },
  data() {
    return {
      changePhotodialog: false,
      experienceDialog: false,
      profileDialog: false,
      personalInfoDialog: false,
      familyInfoDialog: false,
      bankInfoDialog: false,
      educationDialog: false,
      emergencyContactDialog: false,
      gliDialog: false,
      nextOfKinDialog: false,
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue,
      file: null,
      media: "data:image/jpeg;base64,",
      myAccount: false,
      hrAccount: false,
      requireUpdate: false,
      pensionManagers: [],
      taxOffices: [],
      profileGLI: false,
      profileNOK: false,
      employee: {
        firstName: null,
        gender: "",
        id: this.$route.params.id,
        lastName: "",
        maritalStatus: null,
        nationality: null,
        passportIdentificationNumber: null,
        passportPhoto: null,
        phone: "",
        religion: null,
        casualWorkerBank: null,
        designation: {
          department: {}
        },
        casualWorkerStatutory: {
          id: 0,
          salaryBasis: "",
          salaryAmount: 0.0
        },
        casualWorkerTax: {
          id: 0,
          tin: "",
          taxCode: "",
          taxOffice: "",
          tax: {}
        }
      },
      employeePF: 0
    };
  },
  watch: {
    requireUpdate(val) {
      if (val) this.GetEmployeeOtherDetails();
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.GetTaxOffice();
      this.GetEmployee();
      // console.log(this.currentUser);
      this.myAccount =
        this.currentUser.employee.id == this.employee.id ||
        this.currentUser.role == "HRAdmin";
      this.hrAccount = this.currentUser.role == "HRAdmin";
    } else {
      this.$route.push("/employees");
    }
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  methods: {
    openProfile() {
      this.profileDialog = true;
      this.requireUpdate = false;
    },
    openPersonalInfo() {
      this.personalInfoDialog = true;
      this.requireUpdate = false;
    },
    openBankInfo() {
      this.bankInfoDialog = true;
      this.requireUpdate = false;
    },
    closeBankInfo() {
      this.bankInfoDialog = false;
      this.requireUpdate = true;
    },
    closeProfileInfo() {
      this.profileDialog = false;
      this.requireUpdate = true;
    },
    closePersonalInfo() {
      this.personalInfoDialog = false;
      this.requireUpdate = true;
    },
    openChangePhoto() {
      this.changePhotodialog = true;
    },
    closeChangePhoto() {
      this.changePhotodialog = false;
    },
    handleFileUpload() {
      this.$refs.file.click();
    },
    onFilePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.file = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.file = files[0];
      workerService.changeCasualWorkerPhoto(files[0], this.employee.id).then(
        model => {
          this.employee = model;
          if (!this.employee.casualWorkerStatutory) {
            this.employee.casualWorkerStatutory = {
              id: 0,
              salaryBasis: "",
              salaryAmount: 0.0
            };
          }
          if (!this.employee.casualWorkerTax) {
            this.employee.casualWorkerTax = {
              id: 0,
              tin: "",
              taxCode: "",
              taxOffice: "",
              tax: {}
            };
          } else {
            this.employee.casualWorkerTax.tax = {
              taxOffice: this.employee.casualWorkerTax.taxCode,
              description: this.employee.casualWorkerTax.taxOffice
            };
          }

          this.closeChangePhoto();
        },
        e => (this.imageError = e.title)
      );
    },
    changeTax(event) {
      var v = event.target.value;
      var tax = this.taxOffices.find(c => c.taxOffice == v);
      this.employee.casualWorkerTax.taxCode = tax.taxOffice;
      this.employee.casualWorkerTax.taxOffice = tax.description;
    },
    GetTaxOffice() {
      paymentService.getTaxOffice(this.company.id).then(
        model => (this.taxOffices = model),
        err => {
          this.taxOffices = [
            { taxOffice: "ABIA", description: "ABIA" },
            { taxOffice: "ABUJA", description: "ABUJA" },
            { taxOffice: "ADAMA", description: "ADAMAWA" },
            { taxOffice: "AKWAI", description: "AKWAIBO" }
          ];
        }
      );
    },
    GetEmployee() {
      workerService.GetCasualWorkerDetail(this.$route.params.id).then(
        model => {
          this.employee = model;
          this.employee.casualWorkerStatutory = {
            id: 0,
            salaryBasis: "",
            salaryAmount: 0.0
          };
          this.employee.casualWorkerTax = {
            id: 0,
            tin: "",
            taxCode: "",
            taxOffice: "",
            tax: {}
          };
          this.GetEmployeeOtherDetails();
        },
        error => {
          this.error = error;
        }
      );
    },
    GetEmployeeOtherDetails() {
      workerService.GetCasualWorkerOtherDetail(this.$route.params.id).then(
        model => {
          this.employee.casualWorkerBank = model.casualWorkerBank;
          this.employee.casualWorkerTax = model.casualWorkerTax;
          this.employee.casualWorkerStatutory = model.casualWorkerStatutory;

          if (!this.employee.casualWorkerStatutory) {
            this.employee.casualWorkerStatutory = {
              id: 0,
              salaryBasis: "",
              salaryAmount: 0.0
            };
          }
          if (!this.employee.casualWorkerTax) {
            this.employee.casualWorkerTax = {
              id: 0,
              tin: "",
              taxCode: "",
              taxOffice: "",
              tax: {}
            };
          } else {
            this.employee.casualWorkerTax.tax = {
              taxOffice: this.employee.casualWorkerTax.taxCode,
              description: this.employee.casualWorkerTax.taxOffice
            };
          }
        },
        error => {
          this.error = error;
        }
      );
    },
    onPostStatutory() {
      this.employee.casualWorkerStatutory.salaryBasis = "monthly";

      if (!this.employee.casualWorkerTax.id) {
        workerService
          .addCasualWorkerStatutory(
            this.employee.id,
            this.employee.casualWorkerTax
          )
          .then(
            model => {
              this.GetEmployee();
            },
            error => {
              this.error = error;
            }
          );
      } else {
        workerService
          .UpdateCasualWorkerStatutory(
            this.employee.id,
            this.employee.casualWorkerTax
          )
          .then(
            model => {
              getEmployeeDetail();
            },
            error => {
              this.error = error;
            }
          );
      }
    }
  },

  name: "profile",
  beforeRouteUpdate(to, from, next) {
    // employeeService.getEmployeeDetail(to.params.id).then(
    //     (model) => {
    //       this.employee = model;

    //       if (!this.employee.casualWorkerPension) {
    //         this.employee.casualWorkerPension = {
    //           id: 0,
    //           pensionNo: "",
    //           employeeRate: "0",
    //           pensionManager: "",
    //         };
    //       } else {
    //         this.employee.casualWorkerPension.employeeRate = model.employeePension.employeeRate.toString();
    //       }
    //       if (!this.employee.casualWorkerStatutory) {
    //         this.employee.casualWorkerStatutory = {
    //           id: 0,
    //           salaryBasis: "",
    //           salaryAmount: 0.0,
    //         };
    //       }
    //       if (!this.employee.casualWorkerTax) {
    //                 this.employee.casualWorkerTax = {
    //                   id: 0,
    //                   tin: "",
    //                   taxCode: "",
    //                   taxOffice: "",
    //                   tax: {}
    //                 }
    //               }else{
    //                 this.employee.casualWorkerTax.tax = { taxOffice: this.employee.casualWorkerTax.taxCode, description: this.employee.casualWorkerTax.taxOffice}
    //               }
    //     },
    //     (error) => {
    //       this.error = error;
    //     }
    //   );
    // next();
    next();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/casualworker/details.vue